export class MessageCancelTrade {
  public username: string;
  public orderid: string;
  public origclordid: string;
  public market: string;
  public quote: string;
  public qtd: string;
  public side: string;
  public enteringtrader: string;
  public account: string;
  public sourceaddress: string;
  public appName: string;
  constructor() { }
}
